export const education = [
  {
    name: "Bandirma Onyedi Eylul University",
    degree: "Bachelor of Management Information Systems",
    startDate: "2019",
    endDate: "2023",
    expected: "2023",
    completed: false,
  },
];
